const functionsToImplement = [
  'addEventListener',
  'dispatchEvent',
  'removeEventListener'
]

class Emitter {
  constructor () {
    let delegate = document.createDocumentFragment()
    functionsToImplement.forEach(functionName => {
      this[functionName] = (...xs) => delegate[functionName](...xs)
    })
  }

  static cloneEvent (className, originalEvent, type = null) {
    let e = document.createEvent(className)
    e.initEvent(type || originalEvent.type, originalEvent.bubbles, originalEvent.cancelable)
    for (let key in originalEvent) {
      try {
        e[key] = originalEvent[key]
      } catch (e) {}
    }
    return e
  }

  static createEvent (className, eventType, eventData = {}) {
    let e = document.createEvent(className)
    e.initEvent(eventType, true, true)
    for (let key in eventData) {
      e[key] = eventData[key]
    }
    return e
  }
}

export default Emitter
